import { createFileRoute } from '@tanstack/react-router';
import ImageImportPage from '@features/admin/image-import/ImageImportPage';

export const Route = createFileRoute('/admin/image-import/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ImageImportPage />;
}
